<template>
  <v-app id="inspire">
    <v-app-bar app
               color="primary"
               :clipped-left="true"
               dark>
      <v-toolbar-title class="mr-3">
        Гибридная почта
      </v-toolbar-title>

      <v-spacer/>
      <v-btn class="white blue--text" small :to="{name: 'web-client-dashboard'}">На главную</v-btn>
    </v-app-bar>
    <v-main>
      <v-container fluid>
        <router-view/>
      </v-container>
    </v-main>

    <v-overlay :value="$store.getters.layoutIsLoading || !$store.getters.appIsInitialized">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script>
export default {
  name: "WebClientLayout"
}
</script>

<style scoped>

</style>